import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=f98d9222&scoped=true&"
import script from "@/views/Curricula/Curriculum.ts?vue&type=script&lang=ts&"
export * from "@/views/Curricula/Curriculum.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Curricula/Curriculum.scss?vue&type=style&index=0&id=f98d9222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98d9222",
  null
  
)

export default component.exports